import type { JSX } from "solid-js"
import { Icon } from "@opencode-ai/ui/icon"

export function BackLabel(props: { children: JSX.Element }) {
  return (
    <span class="inline-flex items-center gap-1.5 align-middle">
      <Icon name="arrow-left" size="small" class="shrink-0 rtl:rotate-180" aria-hidden="true" />
      <span>{props.children}</span>
    </span>
  )
}
